module.exports = __webpack_public_path__ + "static/media/image-768.7845ff5c.jpg";